import { Component, OnInit } from '@angular/core';
import { Pagination } from '../../../core/shared/classes/pagination';
import { Article } from '../../../facturation/shared/classes/article';
import { ArticleService } from '../../../facturation/shared/services/article.service';
import { TRANSLATE } from '../../classes/translatable';
import { AlertService } from '../../services/alert.service';
import { ConfigurationClientService } from '../../../core/services/configuration-client.service';
import { ConfigurationClient } from '../../../core/shared/classes/configuration-client';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-admin-article',
  templateUrl: './admin-article.component.html',
  styleUrls: ['./admin-article.component.css']
})
export class AdminArticleComponent implements OnInit {

  article: Article = null;
  articleToDelete: Article = null;
  tauxNormalTva: number = null;
  maxArticles: number = null;
  configClient: ConfigurationClient = null;
  isGio: boolean = false;

  listArticles: Article[] = [];
  displayedColumns = ['art_code', 'art_libelle', 'art_prix_unitaire_ht', 'art_taux_tva', 'art_etat', 'actions'];
  pagination: Pagination = new Pagination();
  public  currentPage = 1;
  public  maxItemPerPage = 10;
  public  pageSizeOption = [5, 10, 25, 100];

  constructor(
    protected articleService: ArticleService,
    protected alertService: AlertService,
    protected configClientService: ConfigurationClientService,
    protected storageService: StorageService
  ) { }

  ngOnInit() {
    this.isGio = this.storageService.getConfiguration()['methode_numerotation_facture'] === 'giorgetti';
    this.tauxNormalTva = +(localStorage.getItem('tauxNormalTva'));
    this.configClientService.getConfiguration().subscribe(response => {
      this.configClient = response.data;
    });
    this.fetchArticles();
  }

  fetchArticles(params?: {currentPage: number, maxItemPerPage: number}) {
    this.articleService.getList(params).subscribe(response => {
      if (response && response.status === 200) {
        this.listArticles = [];
        this.pagination = new Pagination(response.data.pagination);
        response.data.data.map((article: Article) => {
          this.listArticles.push(new Article(article));
        }); 
        this.maxArticles = response.data.pagination.pageCount * response.data.pagination.itemCountPerPage;
      } else {
        this.alertService.error(response.message);
      }
    });
  }

  onPageChange($event) {
    if ($event.pageSize !== this.maxItemPerPage) {
      this.maxItemPerPage = $event.pageSize;
    } else if (($event.pageIndex + 1) !== this.currentPage) {
      this.currentPage = ($event.pageIndex + 1);
    }

    this.fetchArticles({currentPage: this.currentPage, maxItemPerPage: this.maxItemPerPage});
  }

  onAdd() {
    const newArticle = new Article();
    newArticle.art_etat = true;
    newArticle.art_suppression = false;
    if (this.tauxNormalTva > 0) {
      newArticle.art_taux_tva = this.tauxNormalTva;
    }
    this.toggleDetail(newArticle);
  }

  onChangeArticle(article: Article) {
    this.toggleDetail();

    //Pas besoin de refresh la liste si update car l'instance de l'article a déjà été modifiée
    if (article.art_id > 0) {
      return;
    }
    this.fetchArticles();
  }

  toggleDetail(article?: Article) {
    if (article) {
      this.article = article;
    } else {
      this.article = null;
    }
  }

  toggleDelete(article?: Article) {
    if (article) {
      this.articleToDelete = article;
    } else {
      this.articleToDelete = null;
    }
  }

  deleteArticle() {
    this.articleService.delete(this.articleToDelete.art_id).subscribe(response => {
      if (response.status === 200) {
        this.alertService.success(TRANSLATE(`Article supprimé avec succès`));
        const i = this.listArticles.indexOf(this.articleToDelete);
        this.listArticles.splice(i, i >= 0 ? 1 : 0);
        this.listArticles = [...this.listArticles]; //Force re-render array
        this.toggleDelete();
      } else {
        this.alertService.error(response.message);
      }
    });
  }

}
